export enum KEYWORD {
  LIST = '/keywords/list',
  ADD = '/keywords/add',
  EDIT = '/keywords/edit/:id',
}
